module.exports = __webpack_public_path__ + "img/manjianquan_bg2.a67ab7c1.png";